export default __webpack_public_path__ + "static/button-label-do-light-5128149d2c8a366fd360149cef1e6248c7a172c60ebe40822120c9b94f6d9696.png";